import { FleekError } from './FleekError';

type ObjectId = {
  id: string | null;
};

type User = ObjectId & {
  email: string | null;
};

type ProjectInvitationAlreadyExistErrorOptions = {
  user: User;
  project: ObjectId;
};

export class ProjectInvitationAlreadyExistError extends FleekError<ProjectInvitationAlreadyExistErrorOptions> {
  public name = 'ProjectInvitationAlreadyExistError';

  toString = () => `Project invitation with email ${this.data.user.email} for this project already exist.`;
}
